import { Injectable } from '@angular/core'
import { AuthData } from 'angular2-token'
import { User } from 'models'

@Injectable()
export abstract class IAuthentication {
  currentUser: User
  currentAuthData: AuthData
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/auth/i-authentication.service.ts